import React, { useContext } from 'react';
import styled from 'styled-components';
import { ExplanationTooltip, Flex, Tooltip, TooltipBody } from '@ubeya/shared-web/components';
import useFormattingMap from '@ubeya/shared-web/hooks/useFormattingMap';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import MinimumWageIndicator from './MinimumWageIndicator';

const Container = styled(Flex)`
  align-items: center;
  gap: 4px;
`;
const Wrapper = styled.div`
  font-weight: 500;
`;

const TotalSalaryRenderer = ({ rowData: { summarized, subRows, payrollTotal, payroll } }) => {
  const { t } = useContext(ConfigContext);
  const formattingMap = useFormattingMap();
  const wageType = payroll?.wage?.type;
  const isNotFinalized = wageType === 'notFinalizedPTO' || wageType === 'notFinalizedLeave';

  if (subRows || summarized) {
    return <Wrapper>{formattingMap.currency(payrollTotal)}</Wrapper>;
  }

  return (
    <Container>
      <Tooltip
        body={<TooltipBody body={payroll?.calculationString} maxWidth={400} center={false} />}
        disabled={!payroll?.calculationString}>
        <Wrapper>{formattingMap.currency(payroll?.value)}</Wrapper>
      </Tooltip>
      {isNotFinalized && <ExplanationTooltip body={t('notFinalizedPTO')} />}
      {payroll?.minimumWageWarning && <MinimumWageIndicator minimumWageWarning={payroll.minimumWageWarning} />}
    </Container>
  );
};

export default TotalSalaryRenderer;
